module.exports = __webpack_public_path__ + "static/intertec_screen_3-5ca563c747156ad8bfc7ad827c3e063d.avif";